export default function () {
    const topFromScrollTop = -1 * document.documentElement.scrollTop + 'px'
    document.body.classList.add('no-scroll')
    document.body.style.top = topFromScrollTop
}
